module.exports = __webpack_public_path__ + "static/media/user-avatar.acb687e0.svg";